import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function loadAudienceMetricsApi() {
  try {
    const fd = new FormData();

    const res = await axios.post(`${apiBaseUrl}adminmetricsapis/audience_metrics`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}
